import axios from 'axios';
import Cookies from 'js-cookie';

// Instance cho Lumen API
export const lumenApi = axios.create({
  baseURL: process.env.VUE_APP_LUMEN_API_URL, // URL lấy từ .env
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  withCredentials: true, // Đảm bảo gửi cookie trong request
});

// Instance cho Node.js API
export const nodeApi = axios.create({
  baseURL: process.env.VUE_APP_NODE_API_URL, // URL lấy từ .env
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Đảm bảo gửi cookie trong request
});

// Hàm lấy token từ cookie thay vì sessionStorage
export function getToken() {
  return Cookies.get('accessToken');
}

// Hàm set token vào cookie thay vì sessionStorage
export function setToken(value) {
  //safari test chuyển secure: false vì không chấp nhận http
  Cookies.set('accessToken', value, { expires: 7, secure: true , sameSite: 'Lax'}); // Token hết hạn sau 7 ngày và chỉ gửi qua HTTPS
}

export function removeToken() {
  Cookies.remove('accessToken');
}

// Interceptor cho request để thêm token vào header nếu cần
lumenApi.interceptors.request.use(
  (config) => {
    const token = getToken(); // Lấy token từ cookie
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/** Các endpoint auth công khai: 401 là lỗi nghiệp vụ (vd. sai mật khẩu), không đá phiên. */
function lumenRequestPath(config) {
  if (!config || !config.url) return '';
  let path = config.url;
  if (path.startsWith('http')) {
    try {
      path = new URL(path).pathname;
    } catch {
      return '';
    }
  }
  path = path.split('?')[0];
  return path.startsWith('/') ? path : `/${path}`;
}

function isLumenPublicAuthPath(path) {
  return /^\/auth\/(login|register|verify-email|reset-password|update-password)$/.test(path);
}

let lumenSessionRedirectScheduled = false;

lumenApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const cfg = error.config;
    const path = lumenRequestPath(cfg);

    if (typeof window !== 'undefined' && status === 401 && cfg && !isLumenPublicAuthPath(path)) {
      if (lumenSessionRedirectScheduled) {
        return Promise.reject(error);
      }
      lumenSessionRedirectScheduled = true;

      removeToken();
      localStorage.removeItem('authUser');

      const loginPath = '/login';
      if (window.location.pathname === loginPath || window.location.pathname.endsWith(`${loginPath}/`)) {
        lumenSessionRedirectScheduled = false;
        return Promise.reject(error);
      }

      const from = window.location.pathname + window.location.search + window.location.hash;
      const q = from && from !== loginPath ? `?redirectFrom=${encodeURIComponent(from)}` : '';
      window.location.assign(`${loginPath}${q}`);
    }

    return Promise.reject(error);
  }
);
